calledDuringRender